@if (corporateTaxEntity$ | async) {
  <form [formGroup]="ontvoegingFg">
    <div class="row">
      <div formArrayName="ontvoeging">
        @for (item of ontvoeging.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <snelstart-ui-text-form-control
              [label]="i === 0 ? 'Naam ontvoegde dochter' : ''"
              [required]="true"
              class="custom-input-250"
              formControlName="naamDochter"
              id="naamDochter"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-select-form-control
              [label]="i === 0 ? 'Artikel 15ai toepassen?' : ''"
              [options]="optionsJaNee"
              [required]="true"
              class="custom-input-150"
              formControlName="toepassing15ai"
              id="toepassing15ai"
            >
            </snelstart-ui-select-form-control>
            <snelstart-ui-select-form-control
              [label]="i === 0 ? 'Had dochter een HIR?' : ''"
              [options]="optionsJaNee"
              [required]="true"
              class="custom-input-150"
              formControlName="hirOpBalansOntvoegdeDochter"
              id="hirOpBalansOntvoegdeDochter"
            >
            </snelstart-ui-select-form-control>
            <snelstart-ui-button
              (click)="showDialog()"
              [class]="i === 0 ? 'firstrowbutton' : ''"
              icon="plus"
              type="secondary"
            >Meer gegevens
            </snelstart-ui-button>
            <snelstart-ui-button
              (click)="verwijderRij(i)"
              [class]="i === 0 ? 'firstrowbutton' : ''"
              icon="trash"
              iconType="light"
              id="buttonDelete"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
        }
      </div>
    </div>
  </form>

  <snelstart-ui-button
    (click)="addRij()"
    id="cancel"
    class="snelstart-ui-button"
    icon="plus"
    type="link"
  >Vennootschap toevoegen
  </snelstart-ui-button>
}
